<template>
  <div
    id="app"
    v-bind:class="{
      'is-loading': state.isLoading,
      'open-modal': state.openModal
    }"
  >
    <div v-if="!state.formCompleted">
      <form-builder :steps="steps" :callback="nextStep"></form-builder>
    </div>

  </div>
</template>

<script>
import FormBuilder from "@/components/FormBuilder.vue";
import { getCheckInDataMixin } from "@/mixins.js";

export default {
  name: "App",
  mixins: [getCheckInDataMixin],
  components: {
    FormBuilder
  },
  data() {
    var step1 =  {
          title: "Site Code Requried",
          fields: [
            {
              type: "text",
              name: "Enter Site Code",
              rules: "required",
              value: ""
            }
          ]
        }
    if (window.IS_KIOSK )
    {
      step1.title="Device Code Requried";
      step1.fields[0].name='Enter Device Code'
    } 
    return {
      state: {
        openModal: false,
        isLoading: false,
        activeStep: 0,
        formCompleted: false
      },
      pageName: "Visitor Sign-in",
      brand: {
        name: "Time Cloud",
        logo: "airnz-logo.svg",
        brandColor: "#231f20"
      },
      steps: [step1],
      showSubmitFeedback: false
    };
  },
  computed: {
    currentStep() {
      return this.steps[this.state.activeStep];
    },
    isLastStep() {
      return this.state.activeStep === this.steps.length - 1;
    }
  },
  mounted() {
    if (this.isLastStep) {
      if (localStorage) { // If visit the home page automatically send user to the remindered location page
        var signInCode = localStorage.getItem("signInCode");
        if (signInCode && signInCode.length > 0) {
          window.location = "/" + signInCode;
        }
      }
    }
  },
  methods: {
    nextStep() {
      if (this.isLastStep) {
        //return this.submit();
        //console.log(this.steps[0].fields[0].value);
        return this.getCheckInData(
          this.steps[0].fields[0].value,
          this.getDataCallback
        );
      }
      this.state.activeStep++;
    },
    getDataCallback(locationData) {
      console.log('locationData', locationData);
      this.$router.push({
        name: "signin",
        params: { id: this.steps[0].fields[0].value }
      });
    },
    submit() {
      console.log("submit");
      this.state.isLoading = true;
      this.showSubmitFeedback = true;
      setTimeout(() => {
        //this.showSubmitFeedback = false;
        this.state.formCompleted = true;
      }, 2000);
    }
  }
};
</script>
